/// <amd-module name="typeahead/features/ElasticacheStalenessLogging" />
import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

const configuration: IStripingConfiguration[] = [
    {
        experiment: {
            id: 34812,
            name: "CACHE_STALENESS_LOGGING_FEATURE_GATE",
            value: 1,
        },
    },
];

export class ElasticacheStalenessLogging implements IExperimentalFeature {

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }
}
